import { render, staticRenderFns } from "./BuroListeView.vue?vue&type=template&id=2049468e"
import script from "./BuroListeView.vue?vue&type=script&lang=ts"
export * from "./BuroListeView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports